if (!customElements.get('lc-customer-reviews')) {
  class LcCustomerReviews extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => this.handleClick(e));
    }

    handleClick(e) {
      const tabButton = e.target.closest('.lc-reviews__tab');
      if (tabButton) {
        this.switchTab(tabButton);
        return;
      }

      const videoCard = e.target.closest('.lc-reviews__video-card');
      if (videoCard) {
        this.openVideoModal(videoCard);
        return;
      }

      const loadMoreBtn = e.target.closest('.lc-reviews__load-more-btn');
      if (loadMoreBtn) {
        const grid = loadMoreBtn.closest('.lc-reviews__content-group').querySelector('.lc-reviews__text-grid');
        if (grid) {
          grid.classList.add('lc-reviews__text-grid--show-all');
        }
        return;
      }

      const closeButton = e.target.closest('.lc-reviews__video-modal-close');
      const overlay = e.target.closest('.lc-reviews__video-modal-overlay');
      if (closeButton || overlay) {
        this.closeVideoModal();
      }
    }

    switchTab(activeTab) {
      const targetCategory = activeTab.getAttribute('data-target');
      if (!targetCategory) return;

      const tabs = this.querySelectorAll('.lc-reviews__tab');
      tabs.forEach(tab => tab.classList.remove('is-active'));
      activeTab.classList.add('is-active');

      const contentGroups = this.querySelectorAll('.lc-reviews__content-group');
      contentGroups.forEach(group => {
        const category = group.getAttribute('data-category');
        if (category === targetCategory) {
          group.classList.add('is-active');
          const slider = group.querySelector('lc-slider');
          if (slider && slider.slider) {
            slider.slider.update();
          }
        } else {
          group.classList.remove('is-active');
        }
      });
    }

    openVideoModal(videoCard) {
      const videoUrl = videoCard.getAttribute('data-video-url');
      if (!videoUrl) return;

      const modal = this.querySelector('.lc-reviews__video-modal');
      if (!modal) return;

      const video = modal.querySelector('.lc-reviews__video-modal-video');
      if (video) {
        video.src = videoUrl;
        video.load();
        video.play().catch(() => {});
      }

      modal.classList.add('is-open');
    }

    closeVideoModal() {
      const modal = this.querySelector('.lc-reviews__video-modal');
      if (!modal) return;

      modal.classList.remove('is-open');

      const video = modal.querySelector('.lc-reviews__video-modal-video');
      if (video) {
        video.pause();
        video.src = '';
      }
    }
  }

  customElements.define('lc-customer-reviews', LcCustomerReviews);
}
